import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="account-deletion"
export default class extends Controller {
  static targets = ["form", "passwordInput", "confirmCheckbox", "submitButton"]

  connect() {
    this.checkFormValidity()
  }

  // Called when password input changes
  passwordInputTargetConnected() {
    this.passwordInputTarget.addEventListener("input", () => {
      this.checkFormValidity()
    })
  }

  // Called when checkbox changes
  confirmCheckboxTargetConnected() {
    this.confirmCheckboxTarget.addEventListener("change", () => {
      this.checkFormValidity()
    })
  }

  // Check if form is valid and enable/disable submit button
  checkFormValidity() {
    const hasPassword = this.passwordInputTarget.value.length > 0
    const isConfirmed = this.confirmCheckboxTarget.checked
    
    this.submitButtonTarget.disabled = !(hasPassword && isConfirmed)
    
    // Update button styling based on state
    if (hasPassword && isConfirmed) {
      this.submitButtonTarget.classList.remove("opacity-50", "cursor-not-allowed")
      this.submitButtonTarget.classList.add("hover:bg-red-700")
    } else {
      this.submitButtonTarget.classList.add("opacity-50", "cursor-not-allowed")
      this.submitButtonTarget.classList.remove("hover:bg-red-700")
    }
  }

  // Handle data export button click
  exportData(event) {
    event.preventDefault()
    
    // Show loading state
    const button = event.currentTarget
    const originalText = button.innerHTML
    button.innerHTML = `
      <svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-gray-700" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      Exporting...
    `
    button.disabled = true

    // Make API call to export data
    fetch('/profile/export', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
      }
    })
    .then(response => {
      if (response.ok) {
        return response.blob()
      }
      throw new Error('Export failed')
    })
    .then(blob => {
      // Create download link
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `ceir_account_data_${new Date().toISOString().split('T')[0]}.json`
      document.body.appendChild(a)
      a.click()
      window.URL.revokeObjectURL(url)
      document.body.removeChild(a)
      
      // Show success state
      button.innerHTML = `
        <svg class="w-4 h-4 mr-2 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
        </svg>
        Exported Successfully
      `
      button.classList.add("text-green-600", "border-green-300")
      
      // Reset after 3 seconds
      setTimeout(() => {
        button.innerHTML = originalText
        button.disabled = false
        button.classList.remove("text-green-600", "border-green-300")
      }, 3000)
    })
    .catch(error => {
      console.error('Export error:', error)
      
      // Show error state
      button.innerHTML = `
        <svg class="w-4 h-4 mr-2 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
        Export Failed
      `
      button.classList.add("text-red-600", "border-red-300")
      
      // Reset after 3 seconds
      setTimeout(() => {
        button.innerHTML = originalText
        button.disabled = false
        button.classList.remove("text-red-600", "border-red-300")
      }, 3000)
    })
  }
}